import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import ItemControllerPinText from './ItemControllerPinText';
/**
 * テキストアイテムのアイテムコントローラー
 */
export default class ItemControllerPinPicture extends ItemControllerPinText{

  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
  }

  public initMe(): void {
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);

    // 回転
    this.rotator = new marietta.webcad.control.parts.ControlRotator(viewObj);
    this.rotator.rotateStartFunc = this.rotateStart;
    this.rotator.rotateFunc = this.rotate;

    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnTextSetting = new marietta.webcad.control.parts.ButtonTextSetting(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }

    this.tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);
    this.padding = this.target.itemInfo.font_size / 3;

    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * Translateのアップデート
   */
  public updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.rotation = this.rotation;
    this.spt.update();
  }

 /**
   * ターゲットに合わせて各種パーツリサイズ
   */
 public resizeToTarget() {
    // 位置合わせ
    super.syncMeToTarget();
    // SVGSpriteのwidth/heightに書き換え
    const width: number = 30;
    const height: number = 30;
    super.updateIconButtons();
    // ピッカーの位置調整
    this.rotator?.move(-6.5, -height / 2 - 23);
    // 全体Box
    this.allBox.resize({ width, height });
    this.allBox.move(0, 0);

    this.updateTransforms();
  }

  public hideToolTips(): void {
    super.hideToolTips();
    this.rotator.hide();
  }

  public showToolTips(): void {
    super.showToolTips();
    this.rotator.show();
  }
}
